import { render } from "./targetZone.vue?vue&type=template&id=12b6c94e&scoped=true"
import script from "./targetZone.vue?vue&type=script&lang=js"
export * from "./targetZone.vue?vue&type=script&lang=js"

import "./targetZone.vue?vue&type=style&index=0&id=12b6c94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b6c94e"]])

export default __exports__